var localStorage = window.localStorage

var localStorageSupportedFn = function() {
    var testKey = 'test'
    try {
        localStorage.setItem(testKey, '1')
        localStorage.removeItem(testKey)
        return true
    } catch (error) {
        return false
    }

}

var localStorageSupported = localStorageSupportedFn()

export default localStorageSupported



// WEBPACK FOOTER //
// ./src/tools/storageSupport.js